module.exports = __webpack_public_path__ + "img/unsatisfied.4c0fc45d.png";